<div class="d-flex align-items-center flex-column p-4 justify-content-around">

   <div class="spinner-border text-primary"></div>
   Loading...

</div>
